// extracted by mini-css-extract-plugin
export default {"wrapper":"badge_wrapper__J+Gc0"};